import React, { useEffect, useState, useCallback } from 'react';

import styled from 'styled-components';
import { StyledDrawer } from 'styles/admin';
import { StyledDivider, StyledTypography } from 'styles/common';

import { CHECK_IN_COMMENT_PLACEHOLDER, CHECK_IN_MEETING_NOTES_PLACEHOLDER } from 'constants/ProjectConstants';
import theme from 'constants/theme';

import { CheckInSidePanelHeader } from '../TasksGoalsSidepanelHeader';
import CreateTalkingPointDiscussion from './CreateTalkingPointDiscussion';
import TalkingPointCommentTabs from './TalkingPointCommentTabs';
import TalkingPointComments, { SCROLL_DIRECTION } from './TalkingPointComments';

const TalkingPointDrawer = styled(StyledDrawer)`
  ${(props) => props.theme.breakpoints.up('sm')} {
    .MuiDrawer-paper {
      width: 40%;
      padding: 0;
    }
  }
`;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledCreateTalkingPointDiscussion = styled(CreateTalkingPointDiscussion)`
  flex-shrink: 0;
  margin: 0;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  background: ${(props) => props.theme.palette.background.lighterBlue};
`;

const GrowFlexChild = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  padding: 0 1.5rem;
`;

const MemoTalkingPointCommentTabs = React.memo(TalkingPointCommentTabs);

const TalkingPointPanel = ({
  open,
  onCancel,
  talkingPoint = {},
  checkInId,
  forceUpdateParent,
  currentCheckInInstanceId,
  startTS,
  endTS,
  latestCheckInInstance,
  otherMember,
  scrollType,
  parentTaskId,
  isActiveTask,
}) => {
  const { uuid: talkingPointId, questionText, visibility, questionType } = talkingPoint;
  // const {
  //   otherMember,

  //   setComments: setTalkingQuestionComments,
  //   timelineData
  // } = useContext(CheckInDataContext);

  const [comments, setTalkingQuestionComments] = useState([]);

  // const [selectedTimelineInstanceId, setSelectedTimelineInstanceId] = useState(
  //   latestCheckInInstance.instanceId
  // );

  const addComment = useCallback(
    (comment) => {
      setTalkingQuestionComments((prev) => {
        if (prev.length > 0 && prev[prev.length - 1].instanceId !== latestCheckInInstance.instanceId) {
          return [
            ...prev,
            {
              instanceId: latestCheckInInstance.instanceId,
              dueTS: latestCheckInInstance.dueTS,
              comment: null,
            },
            {
              instanceId: latestCheckInInstance.instanceId,
              dueTS: latestCheckInInstance.dueTS,
              comment,
            },
          ];
        }
        return [
          ...prev,
          {
            instanceId: latestCheckInInstance.instanceId,
            dueTS: latestCheckInInstance.dueTS,
            comment,
          },
        ];
      });
    },
    [setTalkingQuestionComments, latestCheckInInstance]
  );

  const isMeetingNotesQuestion = questionType === 'MEETING_NOTE';

  // const TimelineDataWithoutDummyEntries = timelineData.filter(
  //   item => item.status !== ONE_ON_ONE_STATUSES.DISABLED
  // );

  useEffect(() => {
    // on close of side Panel, clear the state.
    if (!open) {
    }
  }, [open]);

  return (
    <TalkingPointDrawer
      anchor="right"
      open={open}
      onClose={() => {
        forceUpdateParent();
        setTalkingQuestionComments([]);
        onCancel();
      }}
      ModalProps={{
        onBackdropClick: () => {
          onCancel();
        },
      }}
    >
      <Wrapper>
        <CheckInSidePanelHeader
          closePanel={() => {
            forceUpdateParent();
            onCancel();
          }}
          backButtonHandler={() => {
            forceUpdateParent();
            onCancel();
          }}
        >
          <StyledTypography color="textSecondary" topGutter={2} bottomGutter={2} leftGutter={1}>
            Discussion with {otherMember?.firstName || otherMember?.fullName}
          </StyledTypography>
        </CheckInSidePanelHeader>
        <StyledDivider variant="fullWidth" style={{ backgroundColor: theme.palette.borders.lighterGrey }} />
        <StyledTypography bottomGutter={2} topGutter={2} variant="body1" weight={600} leftGutter={3} rightGutter={3}>
          {questionText}
        </StyledTypography>
        {/* <MemoTalkingPointCommentTabs
        {Object.keys(talkingPoint).length > 0 ? (
          <>
            <CheckInSidePanelHeader
              closePanel={() => {
                forceUpdateParent();
                onCancel();
              }}
              backButtonHandler={() => {
                forceUpdateParent();
                onCancel();
              }}
            />
            <StyledDivider variant="fullWidth" />
            <StyledTypography color="textSecondary" topGutter={2} bottomGutter={2}>
              Discussion with {otherMember?.firstName || otherMember?.fullName}
            </StyledTypography>
            <StyledDivider variant="fullWidth" />
            <StyledTypography bottomGutter={2} topGutter={2} variant="body1" weight={600}>
              {questionText}
            </StyledTypography>
            {/* <MemoTalkingPointCommentTabs
          selectedId={selectedTimelineInstanceId}
          setSelectedId={setSelectedTimelineInstanceId}
          data={TimelineDataWithoutDummyEntries}
        /> */}
        <StyledDivider
          variant="fullWidth"
          bottomGutter={3}
          style={{ backgroundColor: theme.palette.borders.lighterGrey }}
        />

        <GrowFlexChild>
          <TalkingPointComments
            taskId={latestCheckInInstance?.instanceId}
            talkingPoint={talkingPoint}
            styleType="chat"
            isMeetingNotesQuestion={isMeetingNotesQuestion}
            comments={comments}
            setTalkingQuestionComments={setTalkingQuestionComments}
            scrollType={scrollType}
            startTS={startTS}
            endTS={endTS}
            parentTaskId={parentTaskId}
            isDisabled={!isActiveTask}
          />
        </GrowFlexChild>
        {scrollType !== SCROLL_DIRECTION.ACCORDION ? (
          <StyledCreateTalkingPointDiscussion
            taskId={checkInId}
            currentCheckInInstanceId={latestCheckInInstance?.instanceId}
            loading={false}
            styleType="chat"
            placeholder={isMeetingNotesQuestion ? CHECK_IN_MEETING_NOTES_PLACEHOLDER : CHECK_IN_COMMENT_PLACEHOLDER}
            talkingPointQuestionId={talkingPointId}
            addComment={addComment}
            // setComments={setTalkingQuestionComments}
            fullWidth
            talkingPointQuestionVisibility={visibility}
            isDisabled={!isActiveTask}
          />
        ) : null}
      </Wrapper>
    </TalkingPointDrawer>
  );
};

export default TalkingPointPanel;
